<template>
<v-chip small outline outlined @click='clicked' >{{object}}</v-chip>
</template>

<script>
export default {
  name: 'ObjectChip',
  props: {
    object: { type: String, default: '' }
  },
  computed: {
    objectType () {
      if (this.object && this.object.indexOf(':') !== -1) {
        return this.object.split(':')[0]
      }
    },
    id () {
      if (this.object && this.object.indexOf(':') !== -1) {
        return this.object.split(':')[1]
      }
    }
  },
  methods: {
    clicked () {
      if (this.objectType && this.id) {
        if (this.objectType === 'appointment') {
          this.gotoPath(`/appointments/${this.id}`)
        }
        if (this.objectType === 'client') {
          this.gotoPath(`/clients/${this.id}`)
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ObjectChip.vue?68d3cc8d